// --- IMPORTS ---
import L from "leaflet";

// --- NAVIGATION IKONER ---
// (befintliga navaids, se din kod ovan)
export const vfrReportingPointIcon = L.divIcon({
  className: "nav-icon vfr-reporting-point",
  html: `<svg width="32" height="32" viewBox="0 0 32 32">
    <polygon points="16,5 27,27 5,27" fill="none" stroke="#6C4E9C" stroke-width="2"/>
  </svg>`,
  iconSize: [32, 32],
  iconAnchor: [16, 16],
});
export const intersectionIcon = L.divIcon({
  className: "nav-icon intersection",
  html: `<svg width="32" height="32" viewBox="0 0 32 32">
    <polygon points="16,5 27,27 5,27" fill="none" stroke="#6C4E9C" stroke-width="2"/>
  </svg>`,
  iconSize: [32, 32],
  iconAnchor: [16, 16],
});
export const vortacIcon = L.divIcon({
  className: "nav-icon vortac",
  html: `<svg width="32" height="32" viewBox="0 0 32 32">
    <circle cx="16" cy="16" r="7" fill="none" stroke="#6C4E9C" stroke-width="2"/>
    <path d="M11,13 Q16,5 21,13" fill="none" stroke="#6C4E9C" stroke-width="2"/>
    <circle cx="13" cy="12" r="1.3" fill="#6C4E9C"/>
    <circle cx="19" cy="12" r="1.3" fill="#6C4E9C"/>
  </svg>`,
  iconSize: [32, 32],
  iconAnchor: [16, 16],
});
export const tacanIcon = L.divIcon({
  className: "nav-icon tacan",
  html: `<svg width="32" height="32" viewBox="0 0 32 32">
    <path d="M8,8 L16,27 L24,8" fill="none" stroke="#6C4E9C" stroke-width="2"/>
    <ellipse cx="16" cy="17" rx="3.5" ry="2" fill="#6C4E9C"/>
  </svg>`,
  iconSize: [32, 32],
  iconAnchor: [16, 16],
});
export const vorIcon = L.divIcon({
  className: "nav-icon vor",
  html: `<svg width="32" height="32" viewBox="0 0 32 32">
    <polygon points="16,6 26,12 26,22 16,28 6,22 6,12" fill="none" stroke="#22226a" stroke-width="2"/>
    <circle cx="16" cy="16" r="2.2" fill="#22226a"/>
  </svg>`,
  iconSize: [32, 32],
  iconAnchor: [16, 16],
});

export const dmeIcon = L.divIcon({
  className: "nav-icon dme",
  html: `<svg width="32" height="32" viewBox="0 0 32 32">
    <rect x="9" y="9" width="14" height="14" fill="none" stroke="#22226a" stroke-width="2"/>
    <circle cx="16" cy="16" r="2.2" fill="#22226a"/>
  </svg>`,
  iconSize: [32, 32],
  iconAnchor: [16, 16],
});

export const vorDmeIcon = L.divIcon({
  className: "nav-icon vor-dme",
  html: `<svg width="32" height="32" viewBox="0 0 32 32">
    <polygon points="16,6 26,12 26,22 16,28 6,22 6,12" fill="none" stroke="#22226a" stroke-width="2"/>
    <rect x="9" y="9" width="14" height="14" fill="none" stroke="#22226a" stroke-width="2"/>
    <circle cx="16" cy="16" r="2.2" fill="#22226a"/>
  </svg>`,
  iconSize: [32, 32],
  iconAnchor: [16, 16],
});

export const ndbIcon = L.divIcon({
  className: "nav-icon ndb",
  html: `<svg width="32" height="32" viewBox="0 0 32 32">
    <circle cx="16" cy="16" r="9" fill="none" stroke="#6C4E9C" stroke-width="2" stroke-dasharray="2,2"/>
    <circle cx="16" cy="16" r="2" fill="#6C4E9C"/>
  </svg>`,
  iconSize: [32, 32],
  iconAnchor: [16, 16],
});
export const waypointIcon = L.divIcon({
  className: "nav-icon waypoint",
  html: `<svg width="32" height="32" viewBox="0 0 32 32">
    <circle cx="16" cy="16" r="5" fill="#A0A0A0"/>
  </svg>`,
  iconSize: [32, 32],
  iconAnchor: [16, 16],
});
export const defaultNavaidIcon = L.divIcon({
  className: "nav-icon default-navaid",
  html: `<svg width="32" height="32" viewBox="0 0 32 32">
    <rect x="8" y="12" width="16" height="8" fill="#CCCCCC" stroke="#6C4E9C" stroke-width="2"/>
  </svg>`,
  iconSize: [32, 32],
  iconAnchor: [16, 16],
});

// --- Aerddromes ikoner ---

export const aerodromeCivilLandIcon = L.divIcon({
  className: "aerodrome-icon civil-land",
  html: `<svg width="32" height="32" viewBox="0 0 32 32">
    <circle cx="16" cy="16" r="8" fill="none" stroke="#0b2958" stroke-width="2"/>
    <line x1="16" y1="6" x2="16" y2="26" stroke="#0b2958" stroke-width="2"/>
    <line x1="6" y1="16" x2="26" y2="16" stroke="#0b2958" stroke-width="2"/>
  </svg>`,
  iconSize: [32, 32],
  iconAnchor: [16, 16],
});
export const aerodromeCivilWaterIcon = L.divIcon({
  className: "aerodrome-icon civil-water",
  html: `<svg width="32" height="32" viewBox="0 0 32 32">
    <circle cx="16" cy="16" r="8" fill="none" stroke="#0b2958" stroke-width="2"/>
    <line x1="16" y1="6" x2="16" y2="26" stroke="#0b2958" stroke-width="2"/>
    <line x1="6" y1="16" x2="26" y2="16" stroke="#0b2958" stroke-width="2"/>
    <circle cx="16" cy="16" r="2.5" fill="none" stroke="#0b2958" stroke-width="2"/>
    <line x1="16" y1="16" x2="16" y2="23" stroke="#0b2958" stroke-width="2"/>
    <ellipse cx="16" cy="27" rx="4" ry="1.5" fill="none" stroke="#0b2958" stroke-width="2"/>
  </svg>`,
  iconSize: [32, 32],
  iconAnchor: [16, 16],
});
export const aerodromeMilitaryLandIcon = L.divIcon({
  className: "aerodrome-icon military-land",
  html: `<svg width="32" height="32" viewBox="0 0 32 32">
    <circle cx="16" cy="16" r="8" fill="none" stroke="#0b2958" stroke-width="2"/>
    <circle cx="16" cy="16" r="4" fill="none" stroke="#0b2958" stroke-width="2"/>
  </svg>`,
  iconSize: [32, 32],
  iconAnchor: [16, 16],
});
export const aerodromeMilitaryWaterIcon = L.divIcon({
  className: "aerodrome-icon military-water",
  html: `<svg width="32" height="32" viewBox="0 0 32 32">
    <circle cx="16" cy="16" r="8" fill="none" stroke="#0b2958" stroke-width="2"/>
    <circle cx="16" cy="16" r="4" fill="none" stroke="#0b2958" stroke-width="2"/>
    <ellipse cx="16" cy="27" rx="4" ry="1.5" fill="none" stroke="#0b2958" stroke-width="2"/>
  </svg>`,
  iconSize: [32, 32],
  iconAnchor: [16, 16],
});
export const aerodromeJointLandIcon = L.divIcon({
  className: "aerodrome-icon joint-land",
  html: `<svg width="32" height="32" viewBox="0 0 32 32">
    <circle cx="16" cy="16" r="8" fill="none" stroke="#0b2958" stroke-width="2"/>
    <line x1="16" y1="6" x2="16" y2="26" stroke="#0b2958" stroke-width="2"/>
    <line x1="6" y1="16" x2="26" y2="16" stroke="#0b2958" stroke-width="2"/>
    <circle cx="16" cy="16" r="4" fill="none" stroke="#0b2958" stroke-width="2"/>
  </svg>`,
  iconSize: [32, 32],
  iconAnchor: [16, 16],
});
export const aerodromeJointWaterIcon = L.divIcon({
  className: "aerodrome-icon joint-water",
  html: `<svg width="32" height="32" viewBox="0 0 32 32">
    <circle cx="16" cy="16" r="8" fill="none" stroke="#0b2958" stroke-width="2"/>
    <line x1="16" y1="6" x2="16" y2="26" stroke="#0b2958" stroke-width="2"/>
    <line x1="6" y1="16" x2="26" y2="16" stroke="#0b2958" stroke-width="2"/>
    <circle cx="16" cy="16" r="4" fill="none" stroke="#0b2958" stroke-width="2"/>
    <ellipse cx="16" cy="27" rx="4" ry="1.5" fill="none" stroke="#0b2958" stroke-width="2"/>
  </svg>`,
  iconSize: [32, 32],
  iconAnchor: [16, 16],
});
export const aerodromeEmergencyIcon = L.divIcon({
  className: "aerodrome-icon emergency",
  html: `<svg width="32" height="32" viewBox="0 0 32 32">
    <circle cx="16" cy="16" r="8" fill="none" stroke="#0b2958" stroke-width="2"/>
  </svg>`,
  iconSize: [32, 32],
  iconAnchor: [16, 16],
});
export const aerodromeClosedIcon = L.divIcon({
  className: "aerodrome-icon closed",
  html: `<svg width="32" height="32" viewBox="0 0 32 32">
    <circle cx="16" cy="16" r="8" fill="none" stroke="#0b2958" stroke-width="2"/>
    <line x1="8" y1="8" x2="24" y2="24" stroke="#0b2958" stroke-width="3"/>
    <line x1="24" y1="8" x2="8" y2="24" stroke="#0b2958" stroke-width="3"/>
  </svg>`,
  iconSize: [32, 32],
  iconAnchor: [16, 16],
});
export const shelteredAnchorageIcon = L.divIcon({
  className: "aerodrome-icon anchorage",
  html: `<svg width="32" height="32" viewBox="0 0 32 32">
    <path d="M16 6 V20" stroke="#0b2958" stroke-width="2"/>
    <path d="M11 16 Q16 28 21 16" fill="none" stroke="#0b2958" stroke-width="2"/>
    <circle cx="16" cy="22.5" r="2.5" fill="none" stroke="#0b2958" stroke-width="2"/>
    <line x1="16" y1="25" x2="16" y2="28" stroke="#0b2958" stroke-width="2"/>
  </svg>`,
  iconSize: [32, 32],
  iconAnchor: [16, 16],
});
export const aerodromeUnclassifiedIcon = L.divIcon({
  className: "aerodrome-icon unclassified",
  html: `<svg width="32" height="32" viewBox="0 0 32 32">
    <circle cx="16" cy="16" r="7" fill="none" stroke="#0b2958" stroke-width="2"/>
  </svg>`,
  iconSize: [32, 32],
  iconAnchor: [16, 16],
});
export const heliportIcon = L.divIcon({
  className: "aerodrome-icon heliport",
  html: `<svg width="32" height="32" viewBox="0 0 32 32">
    <rect x="8" y="8" width="16" height="16" rx="8" fill="none" stroke="#0b2958" stroke-width="2"/>
    <text x="16" y="22" text-anchor="middle" font-size="14" fill="#0b2958" font-family="Arial" font-weight="bold">H</text>
  </svg>`,
  iconSize: [32, 32],
  iconAnchor: [16, 16],
});

// --- nYA RADIO NAV SYMBOLER ---
export const basicRadioNavIcon = L.divIcon({
  className: "nav-icon basic-radio-nav",
  html: `<svg width="32" height="32" viewBox="0 0 32 32">
    <circle cx="16" cy="16" r="8" fill="none" stroke="#6C4E9C" stroke-width="2"/>
    <circle cx="16" cy="16" r="2.5" fill="#6C4E9C"/>
  </svg>`,
  iconSize: [32, 32],
  iconAnchor: [16, 16],
});
export const markerBeaconEllipticalIcon = L.divIcon({
  className: "nav-icon marker-beacon-elliptical",
  html: `<svg width="32" height="32" viewBox="0 0 32 32">
    <ellipse cx="16" cy="16" rx="10" ry="4" fill="none" stroke="#6C4E9C" stroke-width="2"/>
  </svg>`,
  iconSize: [32, 32],
  iconAnchor: [16, 16],
});
export const markerBeaconBoneIcon = L.divIcon({
  className: "nav-icon marker-beacon-bone",
  html: `<svg width="32" height="32" viewBox="0 0 32 32">
    <path d="M6,16 Q12,6 16,16 Q20,6 26,16 Q20,26 16,16 Q12,26 6,16 Z" fill="none" stroke="#6C4E9C" stroke-width="2"/>
  </svg>`,
  iconSize: [32, 32],
  iconAnchor: [16, 16],
});

// --- UPPDATERAD FUNKTION FÖR ATT HÄMTA IKON UTIFRÅN TYP ---
export function getNavaidIcon(type) {
  if (!type || type.trim() === "" || type.trim() === "-") return defaultNavaidIcon;
  // Ta första ordet, ignorera resten
  const mainType = type.trim().split(" ")[0];
  // Normalisera: ersätt bindestreck med underscore, gör till versaler
  const normalized = mainType.replace(/-/g, "_").toUpperCase();
  switch (normalized) {
    case "VOR": return vorIcon;
    case "VOR/DME":
    case "DVOR/DME": return vorDmeIcon;
    case "DME":
    case "DME_N": return dmeIcon;
    case "NDB": return ndbIcon;
    case "VORTAC": return vortacIcon;
    case "TACAN": return tacanIcon;
    case "WAYPOINT": return waypointIcon;
    case "VFR_REPORTING_POINT":
    case "VFR_REPORTINGPOINT": return vfrReportingPointIcon;
    case "INTERSECTION": return intersectionIcon;
	case "L":
	case "LLZ":
	case "LOC":
	case "ILS_LOC":
	case "ILS_LOC_SINGLEFREQ":
	case "GP":
	case "ILS_GP_MTYPE":
	case "MLS_AZ":
	case "MLS_EL":
	case "BASIC_RADIO_NAV": return basicRadioNavIcon;
	case "MM":
	case "OM":
	case "MARKERS":
    case "MARKER_BEACON_ELLIPTICAL": return markerBeaconEllipticalIcon;
    case "MARKER_BEACON_BONE": return markerBeaconBoneIcon;
    case "CIVIL_LAND": return aerodromeCivilLandIcon;
    case "CIVIL_WATER": return aerodromeCivilWaterIcon;
    case "MILITARY_LAND": return aerodromeMilitaryLandIcon;
    case "MILITARY_WATER": return aerodromeMilitaryWaterIcon;
    case "JOINT_LAND": return aerodromeJointLandIcon;
    case "JOINT_WATER": return aerodromeJointWaterIcon;
    case "EMERGENCY": return aerodromeEmergencyIcon;
    case "CLOSED": return aerodromeClosedIcon;
    case "ANCHORAGE": return shelteredAnchorageIcon;
    case "UNCLASSIFIED": return aerodromeUnclassifiedIcon;
    case "HELIPORT": return heliportIcon;
    default:
      return defaultNavaidIcon;
  }
}

const NAV_AID_TYPE_LABELS = {
  DF:                  'DF',
  DME:                 'DME Directional',
  DME_N:               'DME Omnidirectional',
  GBAS_GroundReceiver: 'GBAS ground reference receiver',
  GBAS_VDF_Station:    'GBAS VDF station',
  ILS_GP_MType:        'ILS GP M-type dual freq.',
  ILS_LOC:             'LOC dual freq.',
  ILS_LOC_SingleFreq:  'LOC single freq.',
  Markers:             'Marker',
  MLS_AZ:              'MLS AZ',
  MLS_EL:              'MLS EL',
  NDB:                 'NDB',
  PSR:                 'PSR',
  SSR:                 'SSR',
  VDB:                 'VDB',
  VHF_Rx:              'VHF Rx',
  VHF_Tx:              'VHF Tx',
  VOR:                 'VOR',
  'VOR/DME':           'VOR / DME Omnidirectional',
};

export function getNavAidTypeLabel(type) {
  if (!type) return '';
  return NAV_AID_TYPE_LABELS[type] ?? type;
}